import { useAuth } from "../../../contexts/AuthContext"
import LougoutButton from "../../parts/button/LogoutButton"
import NavBarNavLink from "../../parts/navlinks/NavBarNavLink"
import wandImg from "../../../assets/images/svg/wand.js"
import NavBar from "./navbar/NavBar"

const GlobalHeader = () => {
  const { currentUser, logout } = useAuth()

  const cssHeader = 'w-full flexJustifyItemsCenter flex-col'
  const headerCss = currentUser ? `${cssHeader} h-[24vh] lg:h-[14vh] pt-9 lg:pt-5` : `${cssHeader} h-[10vh]`
  const cssDiv = 'w-full global-px flex justify-between items-center text-darkOrange'
  const divCss = currentUser ? `${cssDiv} pb-2` : `${cssDiv} pt-1 pb-2 lg:pt-3 lg:pb-2`

  const logoNavLinkDiv = (
    <div className="h-7 flexJustifyItemsCenter flex-row gap-3 lg:pb-2">
      <div className="h-7 w-7">
        {wandImg}
      </div>
      <h1 className="hidden font-bold text-3xl sm:whitespace-nowrap sm:inline">À vos souhaits</h1>
    </div>
  )

  const navBarBtn = currentUser ? (
    <LougoutButton txt="Déconnexion" btnFunction={logout} />
  ) : (
    <>
      <NavBarNavLink to="login" txt="Connexion" />
      <NavBarNavLink to="signup" txt="Inscription" />
    </>
  )

  return (
    <header className={headerCss}>
      <div className={divCss}>
        <NavBarNavLink to="home" css="flexJustifyItemsCenter" child={logoNavLinkDiv} />
        {currentUser && <NavBar css="hidden lg:flex lg:justify-center" />}
        <div className="flexJustifyItemsCenter gap-3 sm:gap-6 lg:mb-2">{navBarBtn}</div>
      </div>
      {currentUser && <NavBar css="flex sm:justify-center lg:hidden" />}
    </header>
  )
}

export default GlobalHeader